import type { InvoiceData } from '@subscriptions/domain/entities';
import type { InvoiceDataViewDto } from '@subscriptions/application/dtos';

/**
 * Maps an InvoiceData domain entity to InvoiceDataViewDto for presentation.
 *
 * @param data - Domain entity
 * @returns View DTO for UI consumption
 */
export const mapInvoiceDataToViewDto = (data: InvoiceData): InvoiceDataViewDto => ({
  uuid: data.uuid ?? '',
  orgUuid: data.orgUuid ?? '',
  businessName: data.businessName,
  firstName: data.firstName,
  firstLastName: data.firstLastName,
  secondLastName: data.secondLastName,
  postalCode: data.postalCode,
  rfc: data.rfc,
  cfdi: data.cfdi,
  email: data.email,
  taxRegime: data.taxRegime,
});
